import { Component, Input, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-trend',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './trend.component.html',
  styleUrls: ['./trend.component.scss'],
})
export class TrendComponent implements OnInit {
  @Input({ required: true }) valuesToCompare?: { first: number; second: number };
  @Input() styleType: 'extended' | 'compact' = 'extended';
  status?: string;

  constructor() {}

  ngOnInit() {
    if (this.valuesToCompare) {
      this.compareValue(this.valuesToCompare.first, this.valuesToCompare.second);
    }
  }

  private compareValue(first: number, second: number): void {
    if (first < second) {
      this.status = 'growth';
    } else if (first > second) {
      this.status = 'degrowth';
    } else {
      this.status = 'stable';
    }
  }
}

